import React from 'react';
import { ActionBadge } from './action-badge';
import { truncateUuid } from './util';

export interface IClaimIdBadgeProps {
    className?: string;
    claimId: string;
    claimType?: string;
    forceClaim?: boolean;
    onCopy?: (url: string) => void;
    onRemove?: () => void;
    removeLabel?: string;
    openInNewTab?: boolean;
    Symbol?: React.ReactNode;
}

export const ClaimIdBadge: React.FunctionComponent<IClaimIdBadgeProps> = (
    props: IClaimIdBadgeProps,
): React.ReactElement => {
    const { className, claimId, claimType, forceClaim, onCopy, onRemove, removeLabel, openInNewTab, Symbol } = props;
    return (
        <ActionBadge
            className={className}
            hideAction={forceClaim}
            path={`/claims/${claimId}`}
            tooltip="View Claim"
            onCopy={onCopy}
            onRemove={onRemove}
            removeLabel={removeLabel}
            openInNewTab={openInNewTab}
            Symbol={Symbol}>
            {claimType || ''} Claim ID – {truncateUuid(claimId)}
        </ActionBadge>
    );
};
